/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Image_Toggle_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to update image compliance setting." |
*
* @param {Compliance_Image_Toggle_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_image_toggle_error = /** @type {((inputs?: Compliance_Image_Toggle_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Image_Toggle_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bild-Compliance-Einstellung konnte nicht aktualisiert werden.")
	return /** @type {LocalizedString} */ ("Failed to update image compliance setting.")
});